import factory from '../../store/factory'

export default {
  users: factory('User'),
  users_logins: factory('UserLogin'),
  roles: factory('Role'),
  roleGroups: factory('RoleGroup')
}